import React from 'react';

import { addIcons } from 'ionicons';

import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import ReactDOM from 'react-dom';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import App from './App';
import { DebugProvider } from './components/Debug';
import { StorageProvider } from './components/Storage';
import reportWebVitals from './reportWebVitals';

addIcons({
  'view-column': '/assets/svg-icons/view-column.svg',
  'sort-alphabet': '/assets/svg-icons/sort-alphabet.svg',
});
if (process.env.REACT_APP_SENTRY) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY,
    release: `${process.env.REACT_APP_SENTRY_ENV}@${process.env.REACT_APP_APP_VERSION}`,
    integrations: [new BrowserTracing()],
    environment: process.env.REACT_APP_SENTRY_ENV,
    sampleRate: 1.0,
    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <StorageProvider>
      <DebugProvider>
        <App />
      </DebugProvider>
    </StorageProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: () => {
    window.postMessage('ReloadServiceWorker');
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(metric => {
  // @ts-ignore
  window.dataLayer = window.dataLayer || [];

  const value = Math.round(
    metric.name === 'CLS' ? metric.value * 1000 : metric.value
  );
  // @ts-ignore
  window.dataLayer.push({
    event: 'web-vitals',
    event_action: metric.name,
    event_value: value,
  });
});
